import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import LocationService from "../../../Setup/controller/LocationController/LocationController";
import PartService from "../../Controller/PartController";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import Cookies from "js-cookie";
import useDateFormat from '../../../Common/fetchDateFormat';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import StockMovementDetail from "./StockMovementDetail";
import HelpSite from "../../../Common/HelpLink";
function StockMovementModal({ modalInstance, close, StockID }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const RoleID = localStorage.getItem('RoleID');
  const HelpLink = localStorage.getItem('HelpLink');
  const location = useLocation();
  const url = new URL(window.location.origin + location.pathname);
  const pathname = "/part/part-list"
  const tableRef = useRef();
  const FormAction = "/PartList";
  //  FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);

  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
  const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  const [selectedId, setSelectedId] = useState("0");
  if (theme == "dark") {
    accordTheme = "accordion-header-dark";
  }
  const [partList, setPartData] = useState([]);
  const [filteredParts, setFilteredParts] = useState([]);
  const [isSerialModalOpen, setIsSerialModalOpen] = useState(false);
  const [isBatchModalOpen, setIsBatchModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const [poCount, setPOCount] = useState(0);

  const [multipleIds, setMultipleIds] = useState([]);
  const CompanyID = localStorage.getItem("CompanyID");
  const UserID = localStorage.getItem("UserID");
  const activeDateFormat = useDateFormat();
  const [quantity, setQuantity] = useState("0");
  const [isMovementModalOpen, setIsMovementModalOpen] = useState(false);
  const [locations, setLocations] = useState([]);
  const [fromLocation, setFromLocation] = useState("");
  const [partMovementList, setPartMovementList] = useState([]);
  const [isDepotPopupOpen, setIsDepotPopupOpen] = useState(false);
  const [depotForm, setDepotForm] = useState({ qty: "0" });

  const [isSendPartsModalOpen, setIsSendPartsModalOpen] = useState(false);
  const [finalPartsList, setFinalPartsList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isMoveModalOpen, setIsMoveModalOpen] = useState(false);
  const [movePartsList, setMovePartsList] = useState([]);
  const setSortConfigInCookie = (config) => {
    Cookies.set(`PartSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
  };
  const getSortConfigFromCookie = () => {
    const sortCookie = Cookies.get(`PartSort_${CompanyID}_${UserID}`);
    return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
  };
  const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());

  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };

  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());

  useEffect(() => {
    UserLockRelease();
    fetchParts(currentPage, pageSize);

  }, [currentPage, pageSize]);

  useEffect(() => {
    fetchParts(currentPage, pageSize);
  }, [sortConfig]);

  useEffect(() => {
    fetchLocations();
  }, []);
  const UserLockRelease = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }


    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };

  const fetchParts = async (page, size) => {
    try {

      setLoading(true);
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };

      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();


      const data = await PartService.GetAllNewParts(redirectCallback, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString());
      setFilteredParts(data);
      setPartData(data);

      /* const locations = await LocationService.GetAllLocations();
       const defaultDepotId = locations.find(loc => loc.vc_Name === "Base")?.PK_Location_ID || "";
       const selectedParts = data
         .filter(part => StockID.includes(part.PK_Stock_ID))
         .map(part => ({
           id: part.PK_Stock_ID,
           ProductCode: part.vc_StockCode,
           Description: part.vc_StockName,
           Quantity: depotForm.qty, // Quantity entered in previous modal
           FromDepot: defaultDepotId,           // Default empty
           FreeStock: part.dec_FreeStock
         }));
 
       setMovePartsList(selectedParts);*/

      const leadCount = await PartService.GetPartCount(redirectCallback, searchQuery);
      setPOCount(leadCount[0].TotalRecords);
      setTotalPages(Math.ceil(leadCount[0].TotalRecords / size));
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
    finally {
      setLoading(false); // Stop loading after fetching
    }
  };
  useEffect(() => {

    fetchParts("0", pageSize);
  }, []);


  const handleCloseModal = async () => {
    await PartService.UnLockPart(localStorage.getItem('StockID'));
    if (localStorage.getItem('HasRecordUpdated') == "1") {

      fetchParts("0", pageSize);
    }
    setMultipleIds([]);
    setIsModalOpen(false);
  };

  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('confirmDelete')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await PartService.DeletePart(redirectCallback, multipleIds);
            setMultipleIds([]);
            fetchParts("0", pageSize);
            setSelectedId("0");
            Swal.fire(
              t('deleted'),
              t('deleteSuccess'),
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              'Error!',
              'There was a problem deleting the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete part.',
        'warning'
      );
    }
  };

  const handleCreatePartClick = () => {
    localStorage.setItem('StockID', "");
    localStorage.setItem('StockID', "0");
    localStorage.setItem('HasRecordUpdated', "0");
    setIsModalOpen(true);
  };
  const fetchPartDetail = async (PartID) => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const PartDetail = await PartService.GetPartByID(redirectCallback, PartID);
      return PartDetail;

    } catch (error) {
      console.error('Error fetching supplier details:', error);
    }
  };
  const handleEditClick = async (StockID) => {
    const IsAlreadyLeadID = localStorage.getItem('StockID');
    if (IsAlreadyLeadID) {
      await PartService.UnLockPart(IsAlreadyLeadID);
    }
    const PartDetail = await fetchPartDetail(StockID);
    if (PartDetail.length > 0) {
      localStorage.setItem('StockID', "");
      localStorage.setItem('StockID', StockID);
      localStorage.setItem('HasRecordUpdated', "0");
      setSelectedId(StockID);
      setIsModalOpen(true);

    }
  };

  const truncateText = (text, maxLength = 20) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };
  const getRowColor = (freeStock, rangeFrom, rangeTo) => {
    if (parseFloat(freeStock) < parseFloat(rangeFrom)) {

      return 'red';
    } else if (parseFloat(freeStock) > parseFloat(rangeTo)) {
      return 'blue';
    }
    return 'black'; // Default color or any other color you'd like
  };
  const filterParts = (color) => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
    if (color === 'red') {
      setFilteredParts(partList.filter(part => getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) === 'red'));
    } else if (color === 'blue') {
      setFilteredParts(partList.filter(part => getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) === 'blue'));
    } else {
      // Reset to show all parts
      setFilteredParts(partList);
    }
  };
  const handleCheckboxChange = (event, id) => {
    event.stopPropagation();
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
    setMultipleIds((prevSelectedIds) => {
      if (event.target.checked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };
  const handleSynchronize = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      Swal.fire({
        title: t('areYouSure'),
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Synchronize!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const postData = await PartService.SyncPartToFinancial(multipleIds);
            if (postData && postData.message === "Data saved successfully") {
              Swal.fire(
                'Success!',
                'The data has been processed and will be fully synced shortly.',
                'success'
              );
              await fetchParts("0", pageSize);
            }
          } catch (error) {
            console.error('Error Synchronizing data:', error);
            Swal.fire(
              'Error!',
              'There was a problem in synchronizing the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please select at least one record to synchronize.',
        'warning'
      );
    }

  };

  const handleSerialTracking = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      const partDetail = await PartService.GetPartByID(redirectCallback, ID);
      if (partDetail[0].snt_SerialTracking > 0) {
        setIsSerialModalOpen(true);
      }
      else {
        Swal.fire(
          'Error!',
          'The serial tracking is not enabled for the selected part.',
          'error'
        );
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please select at least one record to synchronize.',
        'warning'
      );
    }

  };

  const handleBatchManagement = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      const partDetail = await PartService.GetPartByID(redirectCallback, ID);
      if (partDetail[0].bit_BatchManagement > 0) {

        setSelectedId(selectedId);
        setIsBatchModalOpen(true);
      }
      else {
        Swal.fire(
          'Error!',
          'The batch management is not enabled for the selected part.',
          'error'
        );
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please select at least one record to synchronize.',
        'warning'
      );
    }

  };



  const redirecttoUnAuthorzied = () => {
    navigate('/Unauthorized'); // Redirect to the login page
  };


  const handlePageChange = (page) => {
    setFilteredParts([]);
    setPartData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };
  const handleSearchButtonClick = async () => {
    setCurrentPage(1); // Reset to first page
    setFilteredParts([]);
    setPartData([]);
    const query = searchQuery.toLowerCase(); // Use current searchQuery state

     let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";
     setSearchOptions(columnsToSearch);

    const leadData = await PartService.GetAllNewParts(redirectCallback, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(),"0",columnsToSearch.toString());
    setFilteredParts(leadData);
    setPartData(leadData);

    const leadCount = await PartService.GetPartCount(redirectCallback, searchQuery,columnsToSearch.toString());
    setPOCount(leadCount[0].TotalRecords);
    setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize)); // Set total pages dynamically
  };
  const handleSort = async (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const newConfig = { key, direction };
    setSortConfig(newConfig);
    setSortConfigInCookie(newConfig);
    setCurrentPage(1);

    setSortConfig({ key, direction });
    const porderData = await PartService.GetAllNewParts(redirectCallback, "1", pageSize.toString(),
      searchQuery.toString(), key.toString(), direction.toString());

    const porderCount = await PartService.GetPartCount(redirectCallback, searchQuery);

    setPOCount(porderCount[0].TotalRecords);
    setFilteredParts(porderData);
    setPartData(porderData);

    setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
  };

  const defaultColumns = [
    "vc_StockCode",
    "vc_StockName",
    "mon_StockPrice",
    "mon_SalesPrice",

    "dec_Quantity",
    "dec_FreeStock",
    "dec_Allocated",

  ];

  const columnOptions = [
    { value: "vc_StockCode", label: "Product Code" },
    { value: "vc_StockName", label: "Description" },
    { value: "mon_StockPrice", label: "Cost Price" },
    { value: "mon_SalesPrice", label: "Sale Price" },

    { value: "dec_Quantity", label: "In Stock" },
    { value: "dec_FreeStock", label: "Free Stock" },
    { value: "dec_Allocated", label: "Allocated" },

  ];
  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`PartsMovementColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`PartsMovementColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };

  const handleStart = (e, ui) => {
    e.stopPropagation();
  };
  const fetchLocations = async () => {
    try {

      const data = await LocationService.GetAllLocations();
      const defaultDepot = locations.find(loc => loc.vc_Name === "Base")?.PK_Location_ID || "";
      setLocations(data);
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  };
  const handleDepotSubmit = () => {
    if (!depotForm.qty || parseInt(depotForm.qty) <= 0) {
      Swal.fire("Error!", "Please enter quantity", "error");
      return;
    }

    setIsDepotPopupOpen(false);

    // After saving first popup → open parts modal
    //handleSendParts();
  };

  const handleOpenMove = () => {
    setIsMoveModalOpen(true);
  }
  const handleCloseMove = () => {
    setIsMoveModalOpen(false);
  }
  const fetchInitially = () => {
    debugger;
    const selectedParts = partList
      .filter(part => StockID.includes(part.PK_Stock_ID))
      .map(part => ({
        id: part.PK_Stock_ID,
        ProductCode: part.vc_StockCode,
        Description: part.vc_StockName,
        Quantity: depotForm.qty, // Quantity entered in previous modal
        FromDepot: "0"           // Default empty
      }));

    setMovePartsList(selectedParts);


  };
  const [showMoveModal, setShowMoveModal] = useState(false);
  const handleMoveClick = async () => {
    const redirectCallback = () => {
      navigate('/'); // Redirect if unauthorized
    };

    const defaultDepotId = locations.find(loc => loc.vc_Name === "Base")?.PK_Location_ID || "";

    const selectedParts = await Promise.all(
      partList
        .filter(part => multipleIds.includes(part.PK_Stock_ID))
        .map(async (part) => {
          let freeStock = part.dec_FreeStock; // fallback
          let partLocations = [];

          try {
            partLocations = await PartService.GetPartLocation(redirectCallback, part.PK_Stock_ID);
            const defaultLocation = partLocations.find(l => l.FK_Location_ID === defaultDepotId);
            if (defaultLocation) freeStock = defaultLocation.dec_Quantity;
          } catch (error) {
            console.error("Error fetching part locations:", error);
          }

          return {
            id: part.PK_Stock_ID,
            ProductCode: part.vc_StockCode,
            Description: part.vc_StockName,
            Quantity: depotForm.qty,
            FromDepot: defaultDepotId,
            FreeStock: freeStock,
            Locations: partLocations // store locations for dropdown
          };
        })
    );

    setMovePartsList(selectedParts);
    setIsMoveModalOpen(false);
  };
  const handleMoveSubmit = async () => {
    // Validation: quantity > 0 and depot selected
    debugger;
    for (let part of movePartsList) {
      if (!part.Quantity || part.Quantity <= 0) {
        Swal.fire("Error!", "Please enter valid quantity for all parts.", "error");
        return;
      }
      if (!part.FromDepot || part.FromDepot <= 0) {
        Swal.fire("Error!", "Please select From Depot for all parts.", "error");
        return;
      }
    }

    try {
      // Call your API / service to save data
      const ID = StockID;
      const ToDepot = fromLocation;

      await PartService.MoveParts(movePartsList, StockID, ToDepot);
      Swal.fire("Success!", "Parts moved successfully.", "success");

      setIsMoveModalOpen(false);         // Close modal
      fetchParts(currentPage, pageSize);  // Refresh table
      setMultipleIds([]);                 // Reset selection
    } catch (error) {
      Swal.fire("Error!", "Failed to move parts.", "error");
    }
  };
  const handleDeletePart = (partId) => {
    const updatedList = movePartsList.filter(part => part.id !== partId);
    setMovePartsList(updatedList);
  };

  const defaultColumnsForSearch = [
    "vc_StockCode",
    "vc_StockName",
    "mon_StockPrice",
    "mon_SalesPrice",
    "FK_StockCategory_ID",
    "vc_Barcode",
    "dec_Quantity",
    "dec_FreeStock",
    "dec_UnitWeight",
    "dec_Allocated",
    "dec_OnOrder",
    "psync",
    "StockType",
    "ModifiedBy"
  ];

  const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
  const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
  const columnSearchOptions = [
    { value: "vc_StockCode", label: "Product Code" },
    { value: "vc_StockName", label: "Description" },
    { value: "mon_StockPrice", label: "Cost Price" },
    { value: "mon_SalesPrice", label: "Sale Price" },
    { value: "FK_StockCategory_ID", label: "Discount Category" },

    { value: "vc_Barcode", label: "Barcode" },
    { value: "dec_Quantity", label: "In Stock" },
    { value: "dec_FreeStock", label: "Free Stock" },
    { value: "dec_UnitWeight", label: "Weight" },
    { value: "dec_Allocated", label: "Allocated" },
    { value: "dec_OnOrder", label: "On Order" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "psync", label: "Sync" },
    { value: "StockType", label: "Type" },
    { value: "ModifiedBy", label: "ModifiedBy" },


  ];
  return (
    <div>

      <div className="modal fade show d-block" tabIndex="-1" aria-labelledby="stockMovementModalLabel"
      >
        <div className="modal-dialog modal-lg" style={{ width: "65%", left: "15vh", top: "4vh" }}>
          <Draggable
            handle=".modal-header"
            onStart={handleStart}
            bounds={{ top: -40, bottom: window.innerHeight - 400 }}
            cancel="input, textarea, select, button"
          >
            <div className="modal-content">
              {/* Header */}
              <div className={`modal-header ${accordTheme}`}>
                <h5 className="modal-title" id="stockMovementModalLabel">
                  Stock Movement
                </h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={close}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              {/* Body */}
              <div className="modal-body">
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>

                  <label className="col-sm-2 col-form-label">To Depot:<span style={{ color: "red" }}>*</span></label>

                  <div className="col-sm-3">

                    <select
                      className="form-control"
                      value={fromLocation}
                      onChange={(e) => setFromLocation(e.target.value)}
                    >
                      <option value=""></option>
                      {locations.map((loc) => (
                        <option key={loc.PK_Location_ID} value={loc.PK_Location_ID}>
                          {loc.vc_Name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-7">
                    <HelpSite FormName="Stock Movement" Module="5" />
                  </div>
                </div>
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                  <label className="col-sm-2 col-form-label"></label>
                  <div className="col-sm-4">
                    <button
                      className="btn btn-success btn-sm ms-2"
                      style={{ marginLeft: "5px" }}
                      onClick={() => handleOpenMove()}
                    >
                      Pick Stock
                    </button>
                  </div>
                </div>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Product Code</th>
                      <th>Quantity</th>
                      <th>From Depot</th>
                      <th>Free</th>
                      <th>Description</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {movePartsList.map((part, index) => {
                      const isOverStock = Number(part.Quantity) > Number(part.FreeStock);

                      return (
                        <tr key={part.id}>
                          <td style={{ color: isOverStock ? 'red' : 'inherit' }}>{part.ProductCode}</td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={part.Quantity}
                              style={{ color: isOverStock ? 'red' : 'inherit' }}
                              onChange={(e) => {
                                const newList = [...movePartsList];
                                newList[index].Quantity = e.target.value;
                                setMovePartsList(newList);
                              }}
                            />
                          </td>
                          <td>
                            <select
                              className="form-control"
                              value={part.FromDepot}
                              style={{ color: isOverStock ? 'red' : 'inherit' }}
                              onChange={(e) => {
                                const newList = [...movePartsList];
                                newList[index].FromDepot = e.target.value;

                                const selectedLocation = part.Locations.find(
                                  loc => loc.FK_Location_ID.toString() === e.target.value
                                );
                                newList[index].FreeStock = selectedLocation ? selectedLocation.dec_Quantity : 0;

                                setMovePartsList(newList);
                              }}
                            >
                              <option value="">From Depot</option>
                              {part.Locations
                                .filter(loc => loc.FK_Location_ID.toString() != fromLocation.toString())
                                .map((loc) => (
                                  <option key={loc.FK_Location_ID} value={loc.FK_Location_ID}>
                                    {loc.vc_Name}
                                  </option>
                                ))}
                            </select>
                          </td>
                          <td style={{ color: isOverStock ? 'red' : 'inherit' }}>{part.FreeStock}</td>
                          <td style={{ color: isOverStock ? 'red' : 'inherit' }}>{part.Description}</td>
                          <td>
                            <button
                              style={{ border: "none", color: "red", cursor: "pointer" }}
                              onClick={() => handleDeletePart(part.id)}
                            >
                              X
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>

                </table>


              </div>


              {/* Footer */}
              <div className="modal-footer">
                <button
                  className="btn btn-success"
                  onClick={handleMoveSubmit}
                >
                  Submit
                </button>
                <button className="btn btn-secondary" onClick={close}>
                  Close
                </button>
              </div>
            </div>
          </Draggable>
        </div>
      </div>

      {isMoveModalOpen && (
        <div className="modal fade show d-block" style={{ display: 'block' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Move Parts</h5>
                <button className="btn-close" onClick={() => setIsMoveModalOpen(false)}></button>
              </div>

              <div className="modal-body">


                <div className="row mb-3">
                  <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-1" style={{ "textAlign": "right" }}>Search</div>
                  <div className="col-sm-2 d-flex justify-content-end">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state
                      className="form-control me-2" // Add margin to separate input and button
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchButtonClick();
                        }
                      }}
                    />
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                  </div>



                </div>

                <div style={{ maxHeight: "50vh", overflow: "auto" }}>
                  <table style={{ tableLayout: "fixed" }} className="table m-0 table-hover" ref={tableRef}>
                    <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                      <tr>
                        <th style={{ width: "3%" }}></th>
                        {visibleColumns.includes("vc_StockCode") &&
                          <th style={{ width: `${100 / visibleColumns.length}%` }} onClick={() => handleSort('vc_StockCode')} className="no-wrap">{t('productCode')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_StockCode'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                          </th>
                        }
                        {visibleColumns.includes("vc_StockName") &&
                          <th style={{ width: `${100 / visibleColumns.length}%` }} onClick={() => handleSort('vc_StockName')} className="no-wrap">{t('description')}<i
                            className={`ms-1 icofont ${sortConfig.key === 'vc_StockName'
                              ? sortConfig.direction === 'asc'
                                ? 'icofont-caret-up'
                                : 'icofont-caret-down'
                              : 'icofont-sorting'
                              }`}
                          ></i></th>
                        }
                        {visibleColumns.includes("mon_StockPrice") &&
                          <th style={{ width: `${100 / visibleColumns.length}%` }} onClick={() => handleSort('mon_StockPrice')} className="no-wrap">{t('costPrice')}<i
                            className={`ms-1 icofont ${sortConfig.key === 'mon_StockPrice'
                              ? sortConfig.direction === 'asc'
                                ? 'icofont-caret-up'
                                : 'icofont-caret-down'
                              : 'icofont-sorting'
                              }`}
                          ></i></th>
                        }
                        {visibleColumns.includes("mon_SalesPrice") &&
                          <th style={{ width: `${100 / visibleColumns.length}%` }} onClick={() => handleSort('mon_SalesPrice')} className="no-wrap">{t('salePrice')}<i
                            className={`ms-1 icofont ${sortConfig.key === 'mon_SalesPrice'
                              ? sortConfig.direction === 'asc'
                                ? 'icofont-caret-up'
                                : 'icofont-caret-down'
                              : 'icofont-sorting'
                              }`}
                          ></i></th>
                        }

                        {visibleColumns.includes("dec_Quantity") &&
                          <th style={{ width: `${100 / visibleColumns.length}%` }} onClick={() => handleSort('dec_Quantity')} className="no-wrap">{t('inStock')}<i
                            className={`ms-1 icofont ${sortConfig.key === 'dec_Quantity'
                              ? sortConfig.direction === 'asc'
                                ? 'icofont-caret-up'
                                : 'icofont-caret-down'
                              : 'icofont-sorting'
                              }`}
                          ></i></th>
                        }
                        {visibleColumns.includes("dec_FreeStock") &&
                          <th style={{ width: `${100 / visibleColumns.length}%` }} onClick={() => handleSort('dec_FreeStock')} className="no-wrap">{t('freeStock')}<i
                            className={`ms-1 icofont ${sortConfig.key === 'dec_FreeStock'
                              ? sortConfig.direction === 'asc'
                                ? 'icofont-caret-up'
                                : 'icofont-caret-down'
                              : 'icofont-sorting'
                              }`}
                          ></i></th>
                        }
                        {visibleColumns.includes("dec_Allocated") &&
                          <th style={{ width: `${100 / visibleColumns.length}%` }} onClick={() => handleSort('dec_Allocated')} className="no-wrap">{t('allocated')}<i
                            className={`ms-1 icofont ${sortConfig.key === 'dec_Allocated'
                              ? sortConfig.direction === 'asc'
                                ? 'icofont-caret-up'
                                : 'icofont-caret-down'
                              : 'icofont-sorting'
                              }`}
                          ></i></th>
                        }




                      </tr>
                    </thead>


                    <tbody>
                      {filteredParts.map((part, index) => (

                        <tr
                          key={part.PK_Stock_ID}
                          onClick={() => handleEditClick(part.PK_Stock_ID)}
                          style={{
                            backgroundColor: selectedId.toString() === part.PK_Stock_ID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                            cursor: 'pointer',
                          }}
                        >
                          <td className="no-wrap">
                            <input
                              type="checkbox"
                              checked={multipleIds.includes(part.PK_Stock_ID)}
                              onChange={(event) => handleCheckboxChange(event, part.PK_Stock_ID)}
                              onClick={(event) => event.stopPropagation()} // Prevent the checkbox click from triggering row click
                            />
                          </td>
                          {visibleColumns.includes("vc_StockCode") && <td className="no-wrap" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }} >{part.vc_StockCode}</td>}
                          {visibleColumns.includes("vc_StockName") && <td className="no-wrap" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }} title={part.vc_Description}>{part.vc_Description}</td>}
                          {visibleColumns.includes("mon_StockPrice") && <td className="no-wrap" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>{part.Symbol}{part.mon_StockPrice}</td>}
                          {visibleColumns.includes("mon_SalesPrice") && <td className="no-wrap" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>{part.Symbol}{part.mon_SalesPrice}</td>}

                          {visibleColumns.includes("dec_Quantity") && <td className="no-wrap" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>{parseFloat(part.dec_Quantity ?? 0).toFixed(part.DecimalPlaces ?? 0)} {part.Measurment}</td>}
                          {visibleColumns.includes("dec_FreeStock") && <td className="no-wrap" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>{parseFloat(part.dec_FreeStock ?? 0).toFixed(part.DecimalPlaces ?? 0)} {part.Measurment} </td>}
                          {visibleColumns.includes("dec_Allocated") && <td className="no-wrap" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>{parseFloat(part.dec_Allocated ?? 0).toFixed(part.DecimalPlaces ?? 0)} {part.Measurment} </td>}


                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                      <tr>
                        <td colSpan={visibleColumns.length + 1}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                            {/* Last Page Button */}
                            <button
                              style={{ padding: '5px 8px', float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >
                              Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ padding: '5px 8px', float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ padding: '5px 8px', float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ padding: '5px 8px', float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>

              <div className="modal-footer">


                <button type="submit" className="btn btn-primary" onClick={handleMoveClick}>
                  Select
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  aria-label="Close"
                  onClick={handleCloseMove}
                >
                  <i className="icofont-close" aria-hidden="true"> Close</i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}

export default StockMovementModal;
